import React, {useState, useEffect} from "react";

export default function LatzhosePrimoFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M316.818,282.423c-0.187-8.214-0.367-16.118-0.518-23.29c-0.069-2.989-0.124-5.854-0.18-8.56
	c-0.353-17.816-1.194-31.733-2.188-41.865h0.007c0-0.008,0-0.014-0.007-0.014c-0.781-7.966-1.657-13.585-2.464-16.912
	c-0.338-1.394-0.56-2.837-0.663-4.3c-0.049-0.663-0.062-1.347-0.077-2.003c-0.013-0.649-0.034-1.312-0.075-1.974
	c-0.193-2.934-0.297-5.93-0.393-8.822l-0.042-1.029c-0.027-0.815-0.035-1.649-0.048-2.492c-0.028-2.375-0.055-4.825-0.511-7.11
	c-0.407-2.043-1.347-3.879-2.257-5.653c-0.345-0.663-0.698-1.353-1.022-2.043c-0.822-1.767-1.553-3.686-2.147-5.225
	c-1.573-4.107-3.037-8.38-4.334-12.701l-0.283-0.938c-1.091-3.604-2.223-7.325-2.471-11.038c-0.539-7.876-0.863-28.212-0.87-28.419
	v-0.159l-0.153-0.041c-0.013-0.007-0.228-0.062-0.6-0.159l1.85-15.601l0.186-1.622l-0.228-0.014c-0.075,0-7.53-0.421-13.412-0.801
	l-0.207-0.013l-0.021,0.206c-0.186,2.285-0.469,4.749-0.774,7.352c-0.311,2.679-0.628,5.446-0.897,8.449
	c-0.656,0-1.292,0.021-1.905,0.076c-2.306,0.186-5.301,0.67-8.774,1.236c-0.67,0.111-1.36,0.221-2.058,0.339
	c0.016-0.039,0.032-0.083,0.048-0.122l-14.188,1.146c-0.076,0.243-0.156,0.486-0.231,0.729c-1.533,0.083-3.044,0.138-4.508,0.11
	c-1.643,0.021-3.362-0.034-5.115-0.152c-0.022-0.07-0.045-0.141-0.067-0.211l-15.062-1.82l-0.051,0.153
	c-0.4-0.061-0.814-0.124-1.208-0.186c-3.52-0.559-6.564-1.042-8.835-1.222c-0.614-0.055-1.257-0.076-1.905-0.076
	c-0.277-3.003-0.594-5.778-0.905-8.456c-0.296-2.602-0.586-5.06-0.772-7.345l-0.014-0.206l-0.214,0.013
	c-5.881,0.38-13.336,0.801-13.413,0.801l-0.228,0.014l2.037,17.223c-0.367,0.097-0.58,0.152-0.594,0.159l-0.153,0.041l-0.006,0.159
	c0,0.207-0.332,20.543-0.863,28.419c-0.235,3.403-1.187,6.806-2.112,10.099l-0.131,0.462c-1.285,4.59-2.761,9.084-4.391,13.35
	c-1.021,2.671-2.201,5.288-3.499,7.786c-0.159,0.297-0.311,0.58-0.456,0.863c-1.229,2.306-2.195,4.121-1.981,6.972
	c0.358,4.687,0.318,9.567-0.138,15.352c-0.076,0.994-0.117,2.003-0.152,2.982c-0.049,1.035-0.09,2.112-0.179,3.162
	c-0.173,2.084-0.483,4.148-0.918,6.136l-0.083,0.359c-2.493,10.9-4.274,32.057-4.757,56.597c-0.179,9.181-0.427,20.177-0.697,31.823
	c-0.952,41.824-2.036,89.226-0.924,94.79c0.552,2.747,0.641,18.313,0.752,36.344c0.173,28.764,0.387,64.556,2.513,70.314
	l0.034,0.096l0.103,0.035c0.138,0.042,9.306,2.796,23.533,2.789c7.158,0,15.594-0.69,24.802-2.782c0.221,0,0.221,0,0.421-3.541
	c0.117-2.126,0.276-5.163,0.469-8.808c0.38-7.289,0.876-17.002,1.374-26.721c0.994-19.432,1.974-38.863,1.974-38.863
	c0.021-0.58,2.437-57.867,1.83-81.599c0.808-18.079,5.039-35.598,5.087-35.812c0.19-4.957,0.634-11.05,1.327-16.161h0.048v-0.345
	c0.789-5.674,1.89-10.056,3.297-10.153c2.623,0.186,4.191,15.338,4.646,25.976c-0.008,0.131-0.015,0.214-0.015,0.228h0.021
	c0.006,0.166,0.013,0.331,0.021,0.497c0.041,0.173,4.279,17.692,5.08,35.757c-0.601,23.746,1.809,81.033,1.837,81.613
	c0,0,0.973,19.432,1.967,38.863c0.497,9.719,0.994,19.432,1.373,26.721c0.194,3.645,0.36,6.682,0.477,8.808
	c0.193,3.527,0.18,3.534,0.366,3.534c27.563,6.247,48.182,0.062,48.382,0l0.103-0.035l0.035-0.096
	c2.125-5.758,2.34-41.557,2.513-70.314c0.11-18.03,0.2-33.596,0.752-36.344C318.855,371.622,317.777,324.234,316.818,282.423z"
      />
      <rect
        x="208.763"
        y="141.656"
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        width="24.52"
        height="6.833"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M186.922,207.906c0,0,6.542-17.583,9.542-21.667l10.25,0.25l-3.943,7.547l-4.672,10.031l-6.906,17.484
	l-3.641,9.984l-2.844,7.547l0.5-8.641l0.375-7.578l0.672-7.781L186.922,207.906z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M313.64,207.693c0,0-6.542-17.583-9.542-21.667l-10.25,0.25l3.943,7.547l4.672,10.031l6.906,17.484
	l3.641,9.984l2.844,7.547l-0.5-8.641l-0.375-7.578l-0.672-7.781L313.64,207.693z"
      />
      <path
        fill="#010101"
        d="M316.807,282.434c-0.187-8.214-0.367-16.118-0.518-23.29c-0.069-2.989-0.124-5.854-0.179-8.56
	c-0.353-17.816-1.194-31.733-2.188-41.865h0.007c0-0.008,0-0.014-0.007-0.014c-0.781-7.966-1.657-13.585-2.464-16.912
	c-0.338-1.394-0.56-2.837-0.663-4.3c-0.049-0.663-0.062-1.347-0.077-2.003c-0.013-0.649-0.034-1.312-0.075-1.974
	c-0.193-2.934-0.298-5.93-0.393-8.822l-0.042-1.029c-0.027-0.815-0.035-1.649-0.048-2.492c-0.028-2.375-0.055-4.825-0.511-7.11
	c-0.407-2.043-1.347-3.879-2.257-5.653c-0.345-0.663-0.698-1.353-1.022-2.043c-0.822-1.767-1.553-3.686-2.147-5.225
	c-1.573-4.107-3.037-8.38-4.334-12.701l-0.283-0.938c-1.091-3.604-2.223-7.325-2.471-11.038c-0.539-7.876-0.863-28.212-0.87-28.419
	v-0.159l-0.153-0.041c-0.013-0.007-0.228-0.062-0.6-0.159l1.85-15.601l0.186-1.622l-0.228-0.014c-0.075,0-7.53-0.421-13.412-0.801
	l-0.207-0.013l-0.021,0.206c-0.186,2.285-0.469,4.749-0.774,7.352c-0.311,2.679-0.628,5.446-0.897,8.449
	c-0.656,0-1.292,0.021-1.905,0.076c-2.306,0.186-5.301,0.67-8.774,1.236c-0.67,0.111-1.36,0.221-2.058,0.339
	c5.799-14.635,13.675-40.949,15.698-48.224c0.124,4.528,0.206,7.607,0.206,7.724l0.097,3.148l-1.471-0.09l-0.007,0.104l-0.028-0.104
	c-1.001,0.09-1.787,0.87-1.871,1.864c-0.738,8.629-1.566,19.017-1.359,19.521c0.283,0.67,1.774,1.256,1.947,1.318l0.269,0.104
	l0.262-3.728l15.482,0.994l-0.248,3.52l0.262-0.035c0.062-0.007,1.56-0.228,1.994-1.367c0.256-0.656,1.084-13.958,1.423-19.653
	c0.041-0.697-0.366-1.325-1.015-1.574c-0.393-0.152-0.841-0.235-1.311-0.242l-1.14-0.083l-0.407-0.041l-0.173-3.672
	c-0.028-1.691-0.704-41.528-0.87-42.757c-0.042-0.255-0.07-0.532-0.104-0.815c-0.124-1.111-0.255-2.264-0.669-2.913
	c-0.614-0.98-9.933-1.042-12.149-0.083l-0.131,0.055v0.207c-1.049,3.155-2.098,6.302-3.148,9.457
	c-3.81,11.459-7.628,23.125-11.321,34.411l-0.166,0.49c-1.497,4.584-3.017,9.16-4.534,13.737
	c-3.307,9.968-6.723,20.274-9.892,30.476c-1.533,0.083-3.044,0.138-4.508,0.11c-1.643,0.021-3.362-0.035-5.115-0.152
	c-3.168-10.182-6.579-20.474-9.886-30.435c-1.518-4.577-3.03-9.153-4.535-13.737l-0.159-0.49
	c-3.693-11.286-7.51-22.952-11.328-34.411c-1.055-3.182-2.118-6.371-3.182-9.554l0.007-0.11l-0.132-0.055
	c-2.222-0.96-11.535-0.89-12.155,0.083c-0.415,0.649-0.538,1.802-0.67,2.913c-0.028,0.283-0.062,0.56-0.096,0.815
	c-0.166,1.229-0.849,41.065-0.877,42.75l-0.166,3.672l-1.54,0.131c-0.482,0.007-0.924,0.09-1.318,0.242
	c-0.655,0.249-1.062,0.877-1.021,1.574c0.345,5.695,1.173,18.997,1.421,19.653c0.442,1.139,1.94,1.36,2.003,1.367l0.262,0.035
	l-0.256-3.52l15.484-0.994l0.269,3.728l0.269-0.104c0.166-0.062,1.664-0.649,1.94-1.318c0.207-0.504-0.621-10.893-1.353-19.521
	c-0.09-0.994-0.877-1.774-1.871-1.864h-0.042l-1.463,0.09l0.09-3.148c0-0.117,0.09-3.224,0.208-7.793
	c1.988,7.566,9.119,33.438,14.916,48.127c-0.4-0.061-0.814-0.124-1.208-0.186c-3.52-0.559-6.564-1.042-8.835-1.222
	c-0.614-0.055-1.257-0.076-1.905-0.076c-0.277-3.003-0.594-5.778-0.905-8.456c-0.296-2.602-0.586-5.06-0.772-7.345l-0.014-0.206
	l-0.214,0.013c-5.881,0.38-13.336,0.801-13.413,0.801l-0.228,0.014l2.037,17.223c-0.367,0.097-0.58,0.152-0.594,0.159l-0.153,0.041
	l-0.006,0.159c0,0.207-0.332,20.543-0.863,28.419c-0.235,3.403-1.187,6.806-2.112,10.099l-0.131,0.462
	c-1.285,4.59-2.761,9.084-4.391,13.35c-1.021,2.671-2.201,5.288-3.499,7.786c-0.159,0.297-0.311,0.58-0.456,0.863
	c-1.229,2.306-2.195,4.121-1.981,6.972c0.358,4.687,0.318,9.567-0.138,15.352c-0.076,0.994-0.117,2.003-0.152,2.982
	c-0.049,1.035-0.09,2.112-0.179,3.162c-0.173,2.084-0.483,4.148-0.918,6.136l-0.083,0.359c-2.493,10.9-4.274,32.057-4.757,56.597
	c-0.179,9.181-0.427,20.177-0.697,31.823c-0.952,41.824-2.036,89.226-0.924,94.79c0.552,2.747,0.641,18.313,0.752,36.344
	c0.173,28.764,0.387,64.556,2.513,70.314l0.035,0.096l0.103,0.035c0.138,0.042,9.306,2.796,23.533,2.789
	c7.158,0,15.594-0.69,24.802-2.782c0.221,0,0.221,0,0.421-3.541c0.117-2.126,0.276-5.163,0.469-8.808
	c0.38-7.289,0.876-17.002,1.374-26.721c0.994-19.432,1.974-38.863,1.974-38.863c0.021-0.58,2.437-57.867,1.83-81.599
	c0.808-18.079,5.039-35.598,5.087-35.812c0.407-10.624,1.981-26.473,4.673-26.659c2.623,0.186,4.191,15.338,4.646,25.976
	c-0.008,0.131-0.014,0.214-0.014,0.228h0.021c0.006,0.166,0.013,0.331,0.021,0.497c0.041,0.173,4.279,17.692,5.08,35.757
	c-0.601,23.746,1.809,81.033,1.837,81.613c0,0,0.973,19.432,1.967,38.863c0.497,9.719,0.994,19.432,1.373,26.721
	c0.194,3.645,0.36,6.682,0.477,8.808c0.193,3.527,0.179,3.534,0.366,3.534c27.563,6.247,48.182,0.062,48.382,0l0.103-0.035
	l0.035-0.096c2.125-5.758,2.34-41.557,2.513-70.314c0.11-18.03,0.2-33.596,0.752-36.344
	C318.844,371.633,317.766,324.245,316.807,282.434 M315.289,236.757c-7.407-20.398-14.593-39.471-21.22-50.232
	c0.512,0,1.022-0.007,1.526-0.013c1.789-0.021,3.473-0.035,4.653-0.055l3.721-0.07c3.506,5.812,6.627,13.143,9.539,22.407
	C314.219,216.118,314.86,225.423,315.289,236.757 M310.367,187.526c0.104,1.484,0.331,2.955,0.676,4.37
	c0.738,3.023,1.526,7.966,2.25,14.848c-2.706-8.29-5.605-14.965-8.836-20.364c2.948-0.041,5.329-0.062,5.854-0.062
	C310.326,186.718,310.34,187.119,310.367,187.526 M283.335,87.241c0.289-2.526,0.566-4.922,0.752-7.158
	c5.275,0.338,11.707,0.711,12.985,0.78l-1.974,16.712c-2.237-0.566-7.8-1.843-12.66-1.926
	C282.707,92.66,283.024,89.905,283.335,87.241 M298.093,61.258l-0.013-0.379l1.505,0.124c0.434,0.007,0.828,0.076,1.18,0.214
	c0.476,0.18,0.773,0.643,0.746,1.153c-0.525,8.663-1.202,18.976-1.394,19.521c-0.255,0.649-1.001,0.932-1.401,1.042l0.241-3.41
	l-16.332-1.042l-0.255,3.569c-0.566-0.249-1.298-0.65-1.429-0.967c-0.145-0.594,0.656-10.789,1.387-19.335
	c0.061-0.78,0.683-1.394,1.477-1.47l1.478,0.09l0.007,0.145L298.093,61.258z M295.884,10.522c0.36,0.566,0.491,1.719,0.608,2.734
	c0.035,0.284,0.062,0.566,0.097,0.821c0.166,1.201,0.869,42.294,0.876,42.715l0.18,4.011l-11.943-0.69l-0.096-3.334
	c-0.007-0.414-1.112-41.224-1.215-46.229C286.931,9.597,295.387,9.928,295.884,10.522 M265.201,68.707
	c1.518-4.577,3.037-9.16,4.535-13.737l0.159-0.497c3.692-11.286,7.517-22.952,11.328-34.411c0.918-2.775,1.843-5.55,2.768-8.325
	c0.138,5.674,0.635,24.388,0.946,35.84c-1.112,4.335-9.885,34.052-16.153,49.791c-4.21,0.677-8.897,1.367-13.426,1.65
	C258.513,88.877,261.908,78.619,265.201,68.707 M216.356,60.278c0.781,0.069,1.416,0.704,1.478,1.47
	c0.725,8.546,1.526,18.741,1.387,19.322c-0.139,0.324-0.863,0.731-1.43,0.98l-0.255-3.569l-16.339,1.042l0.242,3.41
	c-0.4-0.11-1.146-0.387-1.395-1.042c-0.193-0.545-0.869-10.858-1.394-19.521c-0.035-0.51,0.269-0.973,0.739-1.153
	c0.352-0.138,0.752-0.207,1.194-0.22l1.146-0.084l0.352-0.034l-0.021,0.379l12.806-0.746l0.007-0.145L216.356,60.278z
	 M214.548,56.778l-0.097,3.334l-11.941,0.69l0.186-4.017c0.008-0.414,0.705-41.507,0.87-42.708c0.035-0.255,0.069-0.538,0.103-0.821
	c0.111-1.015,0.242-2.168,0.601-2.734c0.277-0.324,2.934-0.573,5.695-0.573c2.292,0,4.653,0.173,5.799,0.601
	C215.659,15.554,214.562,56.364,214.548,56.778 M215.245,47.528l-0.021,0.008c0.311-11.522,0.814-30.346,0.939-35.895
	c0.938,2.809,1.871,5.618,2.809,8.421c3.811,11.459,7.628,23.125,11.321,34.411l0.159,0.497c1.505,4.577,3.023,9.16,4.541,13.737
	c3.279,9.899,6.676,20.136,9.824,30.269c-4.784-0.338-9.788-1.077-14.228-1.774C224.357,81.504,216.536,52.602,215.245,47.528
	 M203.082,80.863c1.284-0.069,7.717-0.442,12.984-0.78c0.187,2.237,0.462,4.625,0.76,7.151c0.303,2.665,0.621,5.426,0.897,8.415
	c-4.867,0.083-10.423,1.36-12.667,1.926L203.082,80.863z M189.4,194.084l0.084-0.366c0.441-2.009,0.759-4.086,0.932-6.185
	c0.09-1.063,0.131-2.147,0.173-3.189c0.041-0.973,0.082-1.974,0.159-2.961c0.456-5.812,0.496-10.706,0.138-15.414
	c-0.207-2.727,0.739-4.501,1.926-6.744c0.152-0.283,0.303-0.566,0.462-0.863c1.304-2.513,2.492-5.15,3.514-7.835
	c1.636-4.273,3.12-8.78,4.41-13.392l0.132-0.456c0.925-3.313,1.891-6.744,2.126-10.189c0.503-7.517,0.828-26.341,0.863-28.281
	c1.236-0.331,9.699-2.561,15.704-2.071c2.257,0.186,5.295,0.663,8.801,1.222c0.476,0.076,0.966,0.152,1.457,0.228
	c0,0,0,0.007,0.007,0.014l0.02-0.014c6.027,0.953,13.13,1.995,19.321,1.995h0.767c6.854,0.09,14.689-1.18,21.005-2.209
	c3.466-0.559,6.455-1.049,8.74-1.236c6.006-0.49,14.468,1.74,15.704,2.071c0.034,1.94,0.351,20.764,0.863,28.281
	c0.255,3.763,1.387,7.51,2.484,11.134l0.283,0.939c1.305,4.328,2.769,8.615,4.349,12.729c0.594,1.546,1.333,3.472,2.161,5.253
	c0.324,0.697,0.683,1.394,1.022,2.064c0.904,1.746,1.829,3.555,2.222,5.536c0.449,2.243,0.483,4.68,0.512,7.027
	c0.006,0.849,0.014,1.684,0.048,2.506l0.035,1.029c0.096,2.899,0.2,5.895,0.4,8.836c0.041,0.649,0.055,1.312,0.068,1.954
	c0,0.124,0.008,0.248,0.014,0.373c-0.56,0-2.961,0.021-5.923,0.062l-4.142,0.076c-1.18,0.021-2.865,0.035-4.646,0.055
	c-1.111,0.014-2.263,0.021-3.361,0.035c0.255-21.199-0.014-44.337-0.801-68.774l-0.008-0.2l-0.193-0.007
	c-31.25-1.539-57.832-1.691-81.275-0.462l-0.187,0.014l-0.013,0.179c-2.14,23.933-1.83,49.68-1.312,69.498
	c-0.793-0.021-1.608-0.041-2.416-0.055c-2.071-0.048-4.1-0.09-5.542-0.131l-3.997-0.152c-3.224-0.104-5.923-0.138-5.95-0.138
	l-0.007,0.449c0.028,0,2.519,0.035,5.578,0.131c-3.197,5.35-6.075,11.977-8.76,20.17C187.958,201.629,188.648,197.384,189.4,194.084
	 M291.315,127.982c-40.9-1.891-78.596-0.166-81.944-0.007c0.214-3.652,0.476-7.303,0.794-10.9
	c23.331-1.215,49.784-1.063,80.847,0.456C291.122,121.044,291.225,124.523,291.315,127.982 M208.756,142.084h24.285v44.718
	c-3.679-0.035-7.662-0.09-11.943-0.173l-10.547-0.235c-0.532-0.014-1.098-0.028-1.678-0.041
	C208.536,173.41,208.287,157.933,208.756,142.084 M187.095,208.815c2.899-9.236,6.006-16.546,9.498-22.352l3.873,0.145
	c1.449,0.041,3.486,0.083,5.55,0.131c0.13,0,0.262,0.007,0.386,0.007c-6.419,10.534-13.481,29.296-21.357,51.005
	C185.48,226.824,186.183,216.939,187.095,208.815 M249.96,261.594c-2.968,0.787-4.225,15.311-4.674,22.821
	c-0.324-6.972-0.966-21.344-0.746-23.401c0.159-1.477,1.333-2.464,2.016-2.92c1.146-0.766,2.526-1.125,3.404-0.904V261.594z
	 M249.96,256.728c-1.001-0.193-2.431,0.179-3.652,0.994c-1.291,0.863-2.078,2.016-2.216,3.244
	c-0.29,2.747,0.876,26.252,0.932,27.253l0.069-0.007c-0.008,0.145-0.008,0.276-0.014,0.373c-0.041,0.179-4.287,17.734-5.094,35.867
	c0.607,23.732-1.802,81.012-1.83,81.585c-0.034,0.752-3.72,73.909-4.003,77.568c-26.376,5.936-46.318,0.462-47.914,0
	c-2.063-5.992-2.277-41.5-2.45-70.064c-0.111-18.051-0.2-33.638-0.759-36.433c-1.105-5.515,0.028-54.961,0.932-94.694
	c0.269-11.645,0.518-22.641,0.697-31.822c0.077-3.906,0.187-7.731,0.332-11.438c8.104-22.358,15.352-41.742,21.91-52.393
	c1.27,0.028,2.533,0.055,3.638,0.083l10.555,0.235c1.629,0.028,3.202,0.055,4.742,0.083v99.146c0,1.436-0.283,2.844-0.85,4.169
	l-3.727,8.726c-0.304,0.71-1.001,1.173-1.774,1.173c-2.457,0-7.98-0.02-14.6-0.117c-6.627-0.097-14.359-0.276-21.254-0.601
	l-0.021,0.428c13.806,0.649,30.946,0.711,35.874,0.718c0.946,0,1.795-0.565,2.168-1.436l3.728-8.725
	c0.587-1.381,0.884-2.837,0.884-4.335v-99.139c5.543,0.083,10.534,0.131,14.931,0.131c3.251,0,6.171-0.028,8.767-0.076V256.728z
	 M250.167,186.774c-4.549,0.084-10.141,0.097-16.699,0.035v-45.152h-24.705c0.138-4.404,0.325-8.836,0.581-13.247
	c3.037-0.152,40.892-1.905,81.986,0c0.532,20.364,0.697,39.726,0.476,57.694c-0.87,0.014-1.698,0.021-2.43,0.035l-10.423,0.152
	C267.058,186.477,257.374,186.636,250.167,186.774 M250.388,261.594v-4.418c0.877-0.186,2.208,0.173,3.326,0.918
	c0.69,0.456,1.864,1.443,2.023,2.92c0.214,1.995-0.387,15.614-0.718,22.786C254.536,276.118,253.266,262.36,250.388,261.594
	 M317.318,377.107c-0.56,2.796-0.656,18.382-0.766,36.427c-0.166,28.571-0.38,64.08-2.451,70.071c-1.595,0.462-21.509,5.93-47.913,0
	c-0.277-3.596-3.963-76.815-4.004-77.568c-0.021-0.573-2.431-57.853-1.83-81.599c-0.807-18.12-5.052-35.674-5.087-35.812
	c-0.006-0.104-0.006-0.249-0.013-0.407c0.041-0.891,0.973-19.521,0.973-25.61c0-0.766-0.015-1.332-0.048-1.643
	c-0.132-1.229-0.918-2.388-2.216-3.244c-1.187-0.794-2.582-1.174-3.576-1.001v-69.505c7.185-0.131,16.795-0.297,28.571-0.476
	l10.423-0.152c1.285-0.021,2.852-0.041,4.446-0.055l-0.187,0.11c6.751,10.92,14.116,30.594,21.697,51.503
	c0.145,3.914,0.262,8.056,0.345,12.446c0.055,2.707,0.11,5.571,0.18,8.566c0.151,7.165,0.331,15.069,0.518,23.29
	c0.131,5.598,0.262,11.39,0.393,17.223c-13.758,0.635-30.752,0.697-35.647,0.704h-0.006c-0.774,0-1.464-0.462-1.775-1.173
	l-3.72-8.726c-0.567-1.325-0.849-2.734-0.849-4.169v-99.229h-0.428v99.229c0,1.498,0.297,2.954,0.883,4.335l3.728,8.725
	c0.366,0.87,1.221,1.436,2.161,1.436h0.006c4.902-0.007,21.889-0.069,35.654-0.704C317.566,335.524,318.256,372.392,317.318,377.107
	"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8539,0.6406"
        d="
	M184.979,476.365c0,0,22,6.489,49.829,0.181"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8539,0.6406"
        d="
	M315.364,476.365c0,0-22.121,6.489-49.949,0.181"
      />
      <path
        fill="#010101"
        d="M216.846,62.888c-0.021-0.367-0.041-0.704-0.282-0.911c-0.145-0.124-0.353-0.166-0.629-0.146v-0.013
	l-15.075,0.96v0.007c-0.298,0.028-0.518,0.117-0.656,0.276c-0.214,0.248-0.179,0.573-0.159,0.794l0.966,13.537l0.014,0.207
	l8.601-0.545l7.248-0.462l0.946-0.062L216.846,62.888z M215.542,62.266l0.497,6.985c-0.565,0.318-3.251,1.713-7.172,1.92
	c-3.942,0.214-6.558-1.042-7.075-1.318l-0.476-6.676L215.542,62.266z M209.316,76.645l-6.613,0.421l-0.187-2.595l13.716-0.87
	l0.187,2.589L209.316,76.645z M216.839,76.162l-0.214-3.017l-14.565,0.931l0.214,3.017l-0.849,0.055l-0.946-13.24l-0.007-0.097
	c-0.021-0.173-0.041-0.366,0.055-0.469c0.076-0.09,0.228-0.124,0.36-0.132l0.496,6.896l0.09,0.056
	c0.11,0.069,2.506,1.457,6.482,1.457c0.304,0,0.615-0.007,0.932-0.021c4.521-0.242,7.365-1.974,7.49-2.043l0.11-0.069l-0.518-7.234
	c0.152-0.007,0.262,0.007,0.318,0.055c0.104,0.083,0.117,0.324,0.138,0.628l0.939,13.191L216.839,76.162z"
      />
      <path
        fill="#404040"
        d="M297.645,60.803l-11.943-0.69l-0.096-3.334c-0.007-0.415-1.112-41.224-1.215-46.229
	c2.54-0.953,10.996-0.621,11.493-0.028c0.36,0.565,0.491,1.718,0.608,2.734c0.035,0.283,0.062,0.565,0.097,0.821
	c0.166,1.201,0.869,42.294,0.876,42.714L297.645,60.803z"
      />
      <path
        fill="#404040"
        d="M284.937,47.577c-1.111,4.335-9.885,34.052-16.153,49.791c-4.211,0.677-8.898,1.367-13.427,1.651
	c3.155-10.141,6.552-20.399,9.844-30.311c1.518-4.577,3.037-9.16,4.535-13.737l0.159-0.497c3.693-11.286,7.517-22.952,11.328-34.411
	c0.918-2.775,1.843-5.55,2.768-8.325C284.129,17.411,284.626,36.125,284.937,47.577"
      />
      <polygon
        fill="#404040"
        points="216.419,76.189 209.316,76.645 202.703,77.066 202.516,74.471 216.232,73.601 "
      />
      <path
        fill="#404040"
        d="M216.039,69.252c-0.565,0.318-3.251,1.712-7.172,1.919c-3.942,0.215-6.558-1.042-7.075-1.318l-0.476-6.676
	l14.227-0.91L216.039,69.252z"
      />
      <path
        fill="#404040"
        d="M244.817,98.976c-4.784-0.338-9.788-1.078-14.227-1.774c-6.233-15.698-14.054-44.6-15.345-49.673
	l-0.021,0.007c0.311-11.521,0.815-30.345,0.939-35.895c0.939,2.809,1.871,5.619,2.809,8.422c3.81,11.459,7.628,23.125,11.321,34.411
	l0.159,0.497c1.505,4.577,3.023,9.16,4.542,13.737C238.273,78.605,241.669,88.842,244.817,98.976"
      />
      <path
        fill="#404040"
        d="M215.763,10.55c-0.104,5.005-1.201,45.814-1.215,46.229l-0.097,3.334l-11.942,0.69l0.186-4.018
	c0.008-0.413,0.705-41.506,0.87-42.708c0.035-0.255,0.069-0.538,0.103-0.821c0.111-1.015,0.242-2.168,0.601-2.734
	c0.276-0.325,2.934-0.573,5.695-0.573C212.256,9.949,214.617,10.122,215.763,10.55"
      />
      <path
        fill="#010101"
        d="M299.957,63.06c-0.145-0.158-0.367-0.248-0.656-0.275v-0.007l-15.082-0.96v0.014
	c-0.269-0.02-0.477,0.021-0.628,0.146c-0.235,0.207-0.255,0.545-0.283,0.931l-0.974,13.62l0.953,0.062l5.82,0.373l10.022,0.635
	l0.974-13.655l0.014-0.089C300.136,63.633,300.164,63.309,299.957,63.06 M284.619,62.267l14.226,0.911l-0.476,6.676
	c-0.525,0.275-3.148,1.532-7.075,1.318c-3.921-0.207-6.613-1.601-7.18-1.919L284.619,62.267z M297.459,77.066l-8.367-0.538
	l-5.35-0.338l0.187-2.589l13.716,0.869L297.459,77.066z M299.688,63.813l-0.953,13.336l-0.856-0.055l0.221-3.017l-14.572-0.931
	l-0.215,3.017l-0.524-0.035l0.946-13.213c0.021-0.283,0.034-0.525,0.131-0.607c0.062-0.048,0.173-0.068,0.324-0.055l-0.518,7.235
	l0.11,0.068c0.117,0.07,2.961,1.802,7.49,2.043c0.318,0.014,0.628,0.021,0.924,0.021c3.984,0,6.379-1.387,6.483-1.457l0.097-0.055
	l0.49-6.896c0.138,0.008,0.29,0.041,0.366,0.131C299.723,63.447,299.702,63.64,299.688,63.813"
      />
      <polygon
        fill="#404040"
        points="297.645,74.47 297.458,77.066 289.092,76.528 283.742,76.189 283.929,73.601 "
      />
      <path
        fill="#404040"
        d="M298.846,63.177l-0.476,6.676c-0.525,0.275-3.148,1.532-7.075,1.318c-3.921-0.207-6.614-1.601-7.18-1.919
	l0.505-6.985L298.846,63.177z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M250.171,249.455c0.1-0.034,0.202-0.069,0.305-0.105"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        x1="251.082"
        y1="249.132"
        x2="251.083"
        y2="249.132"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M251.083,249.132c1.88-0.172,6.508-0.324,8.604-0.411c1.251-0.052,1.828-1.149,1.891-2.37c0.094-1.835,0.023-3.704,0.023-5.542
	c0.001-5.473-0.089-10.943-0.077-16.416l0.016-7.373c0.006-2.589,0.012-5.177,0.018-7.765c0.006-2.503,0.01-5.006,0.016-7.509
	c0.006-2.204,0.01-4.407,0.015-6.611c0.004-1.688,0.007-3.376,0.011-5.064c0.002-0.957,0.023-1.877,0.026-2.834"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        x1="251.186"
        y1="188.029"
        x2="251.186"
        y2="188.031"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        x1="251.135"
        y1="249.865"
        x2="251.135"
        y2="256.576"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        points="
	251.186,188.03 251.136,243.612 251.136,244.342 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        x1="251.135"
        y1="256.576"
        x2="251.135"
        y2="256.896"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.6406,0.6406"
        d="
	M254.612,279.033c0.286-6.257,0.688-15.873,0.522-17.417c-0.249-2.319-3.392-3.801-4.857-3.364h-0.063
	c-1.465-0.437-4.608,1.044-4.856,3.364c-0.164,1.523,0.224,10.905,0.509,17.165"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.6406,0.6406"
        d="
	M246.721,272.486v-8.677c0-1.116,0.416-2.202,1.202-2.992c0.541-0.543,1.221-0.837,2.205-0.848"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.6406,0.6406"
        d="
	M253.742,272.562l-0.12-8.797c0-1.115-0.416-2.203-1.202-2.992c-0.541-0.543-1.222-0.837-2.204-0.848"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        x1="252.943"
        y1="249.899"
        x2="252.943"
        y2="257.659"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
	261.627,244.342 260.987,244.982 261.627,244.982 261.013,245.595 261.627,245.595 260.86,246.362 261.627,246.362 260.847,247.142 
	261.627,247.142 260.872,247.896 261.627,247.896 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
	251.525,244.576 250.886,245.277 251.525,245.277 250.911,245.949 251.525,245.949 250.759,246.789 251.525,246.789 
	250.746,247.644 251.525,247.644 250.771,248.471 251.525,248.471 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M205.186,98.461c0,0,9.225-2.147,12.768-1.79"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M294.328,98.461c0,0-9.225-2.147-12.768-1.79"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M191.589,184.513c0.001-0.018,0.006-0.151,0.006-0.151c0.04-0.946,0.081-1.923,0.154-2.873c0.46-5.865,0.504-10.831,0.139-15.625
	c-0.176-2.32,0.592-3.77,1.757-5.965l0.472-0.895c1.331-2.549,2.535-5.232,3.586-7.985c1.621-4.226,3.119-8.772,4.45-13.51
	l0.172-0.611c0.931-3.333,1.893-6.78,2.127-10.316c0.433-6.374,0.732-20.578,0.853-27.3 M294.106,99.281
	c0.074,4.267,0.378,20.375,0.848,27.304c0.267,3.916,1.423,7.734,2.542,11.426l0.281,0.946c1.32,4.379,2.794,8.694,4.383,12.83
	c0.731,1.906,1.4,3.624,2.198,5.34c0.26,0.557,0.54,1.111,0.815,1.653l0.226,0.445c0.859,1.664,1.741,3.374,2.101,5.19
	c0.422,2.107,0.451,4.457,0.478,6.729l0.009,0.649c0.01,0.652,0.019,1.299,0.04,1.933l0.042,1.076
	c0.086,2.569,0.194,5.774,0.395,8.832c0.021,0.285,0.036,0.574,0.046,0.864"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M210.756,126.527c0.182-2.934,0.378-5.619,0.594-8.141c9.97-0.494,20.665-0.743,31.811-0.743c14.368,0,29.566,0.394,46.425,1.205
	c0.08,2.578,0.156,5.139,0.224,7.688"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M210.452,140.277c0.116-3.522,0.271-7.06,0.464-10.551c5.02-0.222,20.359-0.819,40.463-0.819c13.591,0,26.659,0.275,38.867,0.818
	c0.494,19.501,0.648,37.996,0.458,55.014"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M231.791,185.408c-3.443-0.037-6.98-0.09-10.535-0.159l-10.912-0.244c-0.284-11.474-0.531-26.237-0.115-41.54h21.561V185.408z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M187.389,211.26c2.736-8.695,6.404-17.809,9.659-23.386"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M203.712,188.074c-5.361,9.512-11.962,27.483-17.959,43.791"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M224.148,188.03v98.546c0,1.153-0.231,2.285-0.686,3.364l-3.688,8.639c-3.205-0.001-8.668-0.032-14.509-0.117
	c-7.323-0.106-15.436-0.208-20.864-0.432"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M313.007,211.26c-2.736-8.695-6.404-17.809-9.659-23.386"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M296.684,188.074c5.361,9.512,11.962,27.483,17.959,43.791"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        d="
	M276.247,188.03v98.546c0,1.153,0.231,2.285,0.686,3.364l3.688,8.639c3.205-0.001,8.668-0.032,14.509-0.117
	c7.323-0.106,15.436-0.208,20.864-0.432"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.3106"
        strokeMiterlimit="10"
        strokeDasharray="0.8346,0.8339"
        x1="210.545"
        y1="148.008"
        x2="231.051"
        y2="148.008"
      />
      <path
        fill="#303030"
        d="M300.764,61.217c-0.351-0.139-0.746-0.207-1.18-0.214l-1.504-0.124l0.013,0.38l-12.804-0.746l-0.007-0.145
	l-1.478-0.09c-0.793,0.077-1.415,0.69-1.477,1.471c-0.731,8.546-1.532,18.741-1.387,19.335c0.13,0.318,0.863,0.718,1.429,0.966
	l0.255-3.569l16.332,1.042l-0.241,3.41c0.4-0.111,1.146-0.394,1.401-1.042c0.193-0.545,0.87-10.859,1.394-19.521
	C301.538,61.859,301.241,61.396,300.764,61.217 M300.116,63.854l-0.015,0.09l-0.973,13.654l-10.022-0.635l-5.82-0.373l-0.953-0.062
	l0.973-13.619c0.028-0.387,0.049-0.725,0.284-0.932c0.151-0.124,0.359-0.166,0.628-0.146v-0.013l15.082,0.959v0.007
	c0.29,0.028,0.512,0.117,0.656,0.276C300.164,63.309,300.136,63.633,300.116,63.854"
      />
      <path
        fill="#303030"
        d="M299.688,63.813l-0.953,13.336l-0.856-0.055l0.221-3.017l-14.572-0.931l-0.215,3.017l-0.524-0.035
	l0.946-13.213c0.021-0.283,0.034-0.525,0.131-0.607c0.062-0.048,0.173-0.068,0.324-0.055l-0.518,7.235l0.11,0.068
	c0.117,0.07,2.961,1.802,7.49,2.043c0.318,0.014,0.628,0.021,0.924,0.021c3.984,0,6.379-1.387,6.483-1.457l0.097-0.055l0.49-6.896
	c0.138,0.008,0.29,0.041,0.366,0.131C299.723,63.447,299.702,63.64,299.688,63.813"
      />
      <path
        fill="#303030"
        d="M217.834,61.749c-0.062-0.766-0.697-1.401-1.478-1.471l-1.483,0.09l-0.007,0.145l-12.806,0.746l0.021-0.38
	l-0.351,0.035l-1.147,0.083c-0.441,0.014-0.841,0.082-1.194,0.22c-0.47,0.18-0.773,0.643-0.739,1.153
	c0.524,8.663,1.201,18.977,1.394,19.522c0.249,0.656,0.995,0.931,1.395,1.042l-0.242-3.409l16.339-1.042l0.255,3.569
	c0.566-0.248,1.291-0.656,1.429-0.98C219.359,80.489,218.558,70.294,217.834,61.749 M216.874,76.59l-7.248,0.463l-8.601,0.545
	l-0.013-0.207l-0.967-13.537c-0.02-0.222-0.055-0.545,0.159-0.795c0.138-0.158,0.358-0.248,0.656-0.275v-0.007l15.076-0.96v0.013
	c0.275-0.02,0.483,0.021,0.628,0.146c0.241,0.207,0.262,0.545,0.282,0.911l0.973,13.641L216.874,76.59z"
      />
      <path
        fill="#303030"
        d="M217.364,76.127l-0.525,0.035l-0.213-3.017l-14.566,0.931l0.215,3.017l-0.85,0.055l-0.946-13.239
	l-0.007-0.097c-0.021-0.173-0.041-0.366,0.055-0.47c0.077-0.089,0.228-0.124,0.36-0.131l0.497,6.896l0.089,0.055
	c0.111,0.07,2.506,1.457,6.482,1.457c0.304,0,0.615-0.007,0.933-0.021c4.521-0.241,7.365-1.974,7.489-2.043l0.11-0.068l-0.518-7.235
	c0.152-0.006,0.262,0.008,0.318,0.055c0.104,0.084,0.117,0.324,0.139,0.629L217.364,76.127z"
      />
      <rect x="212.583" y="122.5" fill="#010101" width="74.667" height="0.583" />
    </svg>
  );
}
